//import ap from '../images/india.png'

const stateLogo=[
 {
   ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'   
},
{
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'
 },
 {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'  
 },
 {
    ap1 :'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
    ap1 :'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
{
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png' 
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'  
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png' 
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'  
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
    ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
 },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png' 
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'  
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
  {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  },
 {
     ap1 : 'https://user-images.githubusercontent.com/42185028/123511030-905a2080-d69c-11eb-813d-5f14bdd0a1a0.png'    
  }]

//console.log(stateLogo)

export default stateLogo;